module.exports = __webpack_public_path__ + "catalog/areas/area/textures/ceramic-tile.jpg";